/**
 * Main js file for widget display-post
 *
 * @package wordpress\sww
 * @since 1.0.6
 * @version 1.0.0
 */

jQuery( function($) {

	var tmp =$( 'div.sww-widget-content-teaser' ).parent();

	$( tmp ).addClass( 'sww-widget-content-teaser-container' );

	return;

} );
